import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'eventName',
      type: 'input',
      label: '标题',
      placeholder: '请输入标题'
    }
  ]
}
